import { Component } from "@angular/core";
import { LucideAngularModule } from "lucide-angular";

@Component({
  selector: "app-club-membership",
  standalone: true,
  imports: [LucideAngularModule],
  templateUrl: "./club-membership.component.html",
  styleUrl: "./club-membership.component.css",
})
export class ClubMembershipComponent {}
